import { ChangeEvent } from "./ChangeEvent";
import { DomEvent } from "./DomEvent";
import { Event, EventListener } from "./Event";
import { RadioGroup } from "../components/radio/RadioGroup";
import { RadioOption } from "../components/radio/RadioOption";

export interface RadioOptionSelectionListener extends EventListener<RadioOptionSelectionEvent> {
}

export abstract class RadioOptionSelectionEvent extends ChangeEvent {
    protected _event: Event;

    constructor(component: RadioGroup, oldSelection: RadioOption, newSelection: RadioOption,
        originatingEvent?: Event|DomEvent) {
        const domEvent = originatingEvent instanceof Event ? originatingEvent.domEvent : originatingEvent;
        super(component, oldSelection, newSelection, domEvent);
    }

    public get group(): RadioGroup {
        return this.target as RadioGroup;
    }

    public get oldSelection(): RadioOption {
        return this.oldValue as RadioOption;
    }

    public get newSelection(): RadioOption {
        return this.newValue as RadioOption;
    }

    public get event(): Event {
        return this._event as Event;
    }
}
